// src/components/strumenti/BudgetPoE.js
import React, { useState } from "react";
import { RefreshCw, Plus, Trash2 } from "lucide-react";
import { leggiNumero } from "../../utils/numeriStrumenti";

const inp = { padding:"8px 10px", border:"1px solid #e5e7eb", borderRadius:8, fontSize:13, fontFamily:"'Inter',sans-serif", outline:"none" };

export default function BudgetPoE() {
  const [dispositivi, setDispositivi] = useState([{ id:1, nome:"", qta:"1", watt:"" }]);
  const [budgetSwitch, setBudgetSwitch] = useState("");

  const totaleW = dispositivi.reduce((s,d) => s + ((parseFloat(d.qta)||0) * (leggiNumero(d.watt)||0)), 0);
  const budget = leggiNumero(budgetSwitch)||0;
  const superaBudget = budget>0 && totaleW>budget;

  const aggiorna = (id, campo, val) => setDispositivi(dd => dd.map(d => d.id===id ? {...d,[campo]:val} : d));
  const aggiungi = () => setDispositivi(dd => [...dd, { id:Date.now(), nome:"", qta:"1", watt:"" }]);
  const rimuovi = id => setDispositivi(dd => dd.length>1 ? dd.filter(d=>d.id!==id) : dd);

  return (
    <div>
      <div style={{ display:"grid", gridTemplateColumns:"1.5fr 60px 80px 24px", gap:6, marginBottom:6, fontSize:10, fontWeight:700, color:"#9ca3af" }}>
        <div>Dispositivo</div><div>Qta</div><div>Watt cad.</div><div></div>
      </div>
      {dispositivi.map(d => (
        <div key={d.id} style={{ display:"grid", gridTemplateColumns:"1.5fr 60px 80px 24px", gap:6, marginBottom:6, alignItems:"center" }}>
          <input value={d.nome} onChange={e=>aggiorna(d.id,"nome",e.target.value)} style={inp} placeholder="Es. Telecamera IP"/>
          <input value={d.qta} onChange={e=>aggiorna(d.id,"qta",e.target.value)} style={inp}/>
          <input value={d.watt} onChange={e=>aggiorna(d.id,"watt",e.target.value)} style={inp} placeholder="Es. 12.9"/>
          <button onClick={()=>rimuovi(d.id)} style={{ background:"none", border:"none", color:"#93c5fd", cursor:"pointer" }}><Trash2 size={14}/></button>
        </div>
      ))}
      <button onClick={aggiungi} style={{ display:"flex", alignItems:"center", gap:4, fontSize:12, color:"#2563eb", background:"none", border:"none", cursor:"pointer", marginBottom:16, fontWeight:600 }}>
        <Plus size={13}/> Aggiungi dispositivo
      </button>

      <div style={{ marginBottom:16 }}>
        <label style={{ fontSize:11, fontWeight:600, color:"#6b7280", display:"block", marginBottom:4 }}>Budget PoE dello switch (W) — facoltativo, per il confronto</label>
        <input value={budgetSwitch} onChange={e=>setBudgetSwitch(e.target.value)} style={{...inp,width:"100%"}} placeholder="Es. 130"/>
      </div>

      <div style={{ background: superaBudget ? "#fef2f2" : "#eff6ff", border:`1px solid ${superaBudget?"#fca5a5":"#bfdbfe"}`, borderRadius:10, padding:"14px 16px", textAlign:"center" }}>
        <div style={{ fontSize:11, color:"#9ca3af", fontWeight:600, marginBottom:4 }}>Potenza PoE totale richiesta</div>
        <div style={{ fontSize:22, fontWeight:800, color: superaBudget ? "#dc2626" : "#2563eb" }}>
          {totaleW.toLocaleString("it-IT",{maximumFractionDigits:1})}
          <span style={{ fontSize:14, marginLeft:6, color:"#9ca3af" }}>W</span>
        </div>
        {superaBudget && (
          <div style={{ fontSize:11, color:"#991b1b", marginTop:6, fontWeight:600 }}>⚠️ Supera il budget PoE dello switch dichiarato</div>
        )}
      </div>

      <button onClick={()=>{setDispositivi([{ id:Date.now(), nome:"", qta:"1", watt:"" }]);setBudgetSwitch("");}}
        style={{ marginTop:16, display:"flex", alignItems:"center", gap:6, fontSize:12, color:"#9ca3af", background:"none", border:"none", cursor:"pointer" }}>
        <RefreshCw size={12}/> Azzera
      </button>
    </div>
  );
}
